import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CSSTransition } from 'react-transition-group';
import type SwiperCore from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import { useModal } from '@/context/ModalContext';

import { HelpTextConfig, type HelpTextStructure } from './HelpTextConfig';

const HelpModal: React.FC = () => {
  const { t } = useTranslation();
  const swiperRef = useRef<SwiperCore | null>(null);
  const [lastElement, setLastElement] = useState<boolean>(false);
  const { helpModal, setHelpModal, helpType } = useModal();

  const helpText: HelpTextStructure = HelpTextConfig();

  const slides = Object.entries(helpText[helpType]);

  useEffect(() => {
    if (slides.length === 1 && helpModal) {
      setLastElement(true);
    }
  }, [slides, helpModal]);

  const handleSlideChange = (swiper: SwiperCore): void => {
    const currentIndex = swiper.activeIndex;
    const lastIndex = slides.length - 1;
    setLastElement(currentIndex === lastIndex);
  };

  return (
    <div className={`modalRewardBackground ${helpModal ? 'open' : ''} isolate`}>
      <CSSTransition
        in={helpModal}
        timeout={300}
        classNames="my-node-help-modal"
        unmountOnExit
      >
        <div className="help_modal_block">
          <div className="help_modal">
            <div className="help_modal_icon">
              <picture>
                <source
                  srcSet="/img/icons/helpCards/helpIcon.webp"
                  type="image/webp"
                />
                <img
                  src="/img/icons/helpCards/helpIcon.png"
                  alt="helpIcon"
                  width={80}
                />
              </picture>
            </div>
            <ul className="help_modal_slide">
              <Swiper
                spaceBetween={10}
                slidesPerView={1}
                centeredSlides={true}
                loop={false}
                allowTouchMove={false}
                onSwiper={(swiper) => {
                  swiperRef.current = swiper;
                }}
                onSlideChange={handleSlideChange}
              >
                {slides.map(([page, value]) => {
                  return (
                    <SwiperSlide key={page}>
                      <li className="help_modal_slide_card">
                        <span>{value.title}</span>
                        <div>
                          {value.paragraf.map((el, index) => (
                            <p key={`p1-${index}`}>{el}</p>
                          ))}
                        </div>
                        {value.addition && (
                          <div>
                            {value.addition.map((el, index) => (
                              <p key={`p2-${index}`}>{el}</p>
                            ))}
                          </div>
                        )}
                      </li>
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            </ul>
            <button
              type="button"
              onClick={() => {
                if (swiperRef.current && !lastElement) {
                  swiperRef.current.slideNext();
                } else {
                  setHelpModal(false);
                  setLastElement(false);
                }
              }}
            >
              <span>{lastElement ? t('It’s clear!') : t('Next')}</span>
            </button>
          </div>
        </div>
      </CSSTransition>
    </div>
  );
};

export default HelpModal;
